export default "__VITE_ASSET__Dt7Nl4nf__"